module.exports = __webpack_public_path__ + "static/media/DSC01497.13e2d350.jpg";